import styled, { css } from 'styled-components'
import media from 'styled-media-query'

type EditorContainerProps = {
  height?: string
}

export const HasHelpButtons = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    font-size: ${theme.font.sizes.xxsmall};
    border-radius: 50%;
    height: 32px;
    width: 32px;
    cursor: pointer;
  `}
`

export const EditorHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 8px;
    position: relative;

    > div {
      text-align: center;
    }

    > h4 {
      color: ${theme.colors.primary};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.normal};
      font-weight: ${theme.font.xbold};
    }

    .help-container {
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 1rem;
      width: 36%;
    }

    .tooptip-custom {
      width: 100%;
      background: ${theme.colors.white} !important;
      opacity: 1 !important;
      text-align: left;
      max-width: 260px;
      box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
      border-radius: ${theme.border.radius};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
    }

    .custom-title-input {
      width: 40%;
      padding: 10px 5px;
      border: none;
      border: 1px solid ${theme.colors.xxxlightGray};
      border-radius: ${theme.border.smallRadius};
      color: ${theme.colors.primary};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.normal};
      font-weight: ${theme.font.xbold};

      ::placeholder {
        color: ${theme.colors.gray};
      }
    }

    .exclusion-block-button {
      position: absolute;
      background: transparent;
      right: -12px;
      top: 12px;
      cursor: pointer;
    }

    .conclusion-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 28px;

      .select-input-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 38px;
        width: 240px;
      }

      ${media.lessThan('medium')`
        margin-right: 0px;

        label {
          padding-left: 0px;
          font-size: ${theme.font.sizes.xxxsmall}
        }

        .select-input-container {
          margin-left: 8px;
          width: 130px;
        }
      `}

      ${media.lessThan('small')`
        flex-direction: column;
      `}
    }
  `}
`

export const EditorContainer = styled.div<EditorContainerProps>`
  ${({ theme, height = '225px' }) => css`
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${theme.border.smallRadius};
    padding: 0 24px;
    margin: 40px 28px;
    background: ${theme.colors.white};

    .jodit-react-container {
      padding-bottom: 20px;

      .jodit-container {
        border: none;

        .jodit-toolbar__box {
          border: 1px solid rgba(66, 82, 110, 0.25);
          z-index: 1;
        }

        .jodit-wysiwyg {
          border: 1px solid rgba(66, 82, 110, 0.25);
          background: ${theme.colors.white};
          box-sizing: border-box;
          box-shadow: inset 0px 1px 3px #dddddd;
          border-radius: 0 0 10px 10px;
          height: ${height};
          padding: 0 14px;
          cursor: auto;

          ::-webkit-scrollbar {
            width: 8px;
          }

          ::-webkit-scrollbar-thumb {
            background: ${theme.colors.primary};
            border-radius: 10px;
          }
        }
      }
    }

    @media print {
      box-shadow: none;
      border-radius: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
    }
  `}
`
